/* Deployment hardening — top-level ErrorBoundary so an unhandled render
 * error in any page never blanks the entire app during the live trial.
 * Renders a quiet inline panel with a Reload button.
 */
import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        className="min-h-screen flex items-center justify-center bg-[var(--sand-50,#F4F1EA)] p-6"
      >
        <div className="max-w-md text-center">
          <div className="text-xs uppercase tracking-[0.18em] text-[var(--ink-500,#78716c)] mb-2">
            Something went wrong
          </div>
          <h1 className="font-heading text-2xl font-semibold mb-3">
            Margin Mate hit an unexpected error
          </h1>
          <p className="text-sm text-[var(--ink-700,#44403c)] mb-6">
            The page failed to render. Your data is safe — refresh to try again, or
            contact support if this keeps happening.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            className="h-11 px-6 rounded-md bg-[var(--ink-900,#1c1917)] text-[var(--sand-50,#F4F1EA)] text-sm font-medium active:scale-[0.98]"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
